/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */

export type AppEnum = typeof AppEnum[keyof typeof AppEnum];


export const AppEnum = {
  AI_CONVERSATION: 'Tools::Ai::Conversation',
  AI_MINI_TOOL: 'Tools::Ai::MiniTool',
  AI_IMAGE: 'Tools::Ai::Image',
  AI_PERSONA: 'Tools::Ai::Persona',
  AI_ASSISTANT: 'Tools::Ai::Assistant',
  AI_DOCUMENT_QA: 'Tools::Ai::DocumentQa',
  AI_FEEDBACK: 'Tools::Ai::Feedback',
  WORKSHEET_WORKSHEET_WIZARD: 'Tools::Worksheet::WorksheetWizard',
  AI_CONVERTER: 'Tools::Ai::Converter',
  PUPIL_FEEDBACK_ASSIGNMENT: 'Tools::PupilFeedback::Assignment',
  WORKSHEET_WORKSHEET: 'Tools::Worksheet::Worksheet',
  WORKSHEET_RESPONSE: 'Tools::Worksheet::Response',
  CLASSROOM_SCREEN_SCREEN: 'Tools::ClassroomScreen::Screen',
  PINBOARD_BOARD: 'Tools::Pinboard::Board',
  SURVEYS_SURVEY: 'Tools::Surveys::Survey',
  TEXT_EDITOR_DOCUMENT: 'Tools::TextEditor::Document',
  WEBSITE_PAGE: 'Tools::Website::Page',
  VIDEO_RECORDER_FILE: 'VideoRecorder::File',
  AUDIO_RECORDER_FILE: 'AudioRecorder::File',
  SCREEN_RECORDER_FILE: 'ScreenRecorder::File',
  WORD_CLOUDS_WORD_CLOUD: 'Tools::WordClouds::WordCloud',
  LINK_SHORTENER_LINK: 'LinkShortener::Link',
  FILE_SHARING_FILE: 'Tools::FileSharing::File',
  QRCODES_QRCODE: 'Tools::Qrcodes::Qrcode',
  SCHOOL_CLASS: 'Tools::SchoolClass',
  PROJECT: 'Tools::Project',
  PUPIL_FEEDBACK_FEEDBACK: 'Tools::PupilFeedback::Feedback',
  PINBOARD_CARD: 'Tools::Pinboard::Card',
  PINBOARD_COMMENT: 'Tools::Pinboard::Comment',
  PINBOARD_LIST: 'Tools::Pinboard::List',
  SURVEYS_SURVEY_RESPONSE: 'Tools::Surveys::SurveyResponse',
  WORD_CLOUDS_WORD_ENTRY: 'Tools::WordClouds::WordEntry',
} as const;
